"use client";

import { c as _c } from "react/compiler-runtime";
import { useIntersectionObserver } from "usehooks-ts";
import { cn } from "@repo/ui/utils.ts";
import { RichTextBodyCopySimple } from "@/components/common/rich-text/rich-text-body-copy-simple.component";
import { RichTextCondensed } from "@/components/common/rich-text/rich-text-condensed.component";
import { getI18nString, getI18nValue, nullToUndefined } from "@/lib/utils";
import { StatisticItem } from "./statistic-item.component";
import type { StatisticsDisplayProps } from "./statistics-display.types";
export function StatisticsDisplay(t0) {
  const $ = _c(17);
  const {
    headline,
    body,
    items,
    className
  } = t0;
  const validItems = items?.filter(_temp) ?? [];
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      threshold: 0.2,
      freezeOnceVisible: true
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    ref,
    isIntersecting
  } = useIntersectionObserver(t1);
  if (!validItems.length) {
    return null;
  }
  let t2;
  if ($[1] !== className) {
    t2 = cn("overflow-clip rounded-t-md bg-surface-base-primary desktop:rounded-t-xl", className);
    $[1] = className;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = "statistics-display";
  const t4 = "container-grid py-16 desktop:py-28";
  const t5 = "col-span-full flex flex-col gap-12 desktop:py-12 desktop:gap-28";
  let t6;
  if ($[3] !== body || $[4] !== headline) {
    t6 = (headline || body) && <div className="flex flex-col gap-6 desktop:flex-row desktop:items-start desktop:justify-between">{headline && <RichTextBodyCopySimple richText={headline} as="heading" className="text-text-primary desktop:max-w-[751px]" />}{body && <RichTextCondensed richText={body} className="text-text-secondary desktop:max-w-[419px]" />}</div>;
    $[3] = body;
    $[4] = headline;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const t7 = "grid grid-cols-1 gap-12 desktop:grid-cols-3 desktop:gap-x-6 desktop:gap-y-28";
  let t8;
  if ($[6] !== isIntersecting) {
    t8 = item_0 => <StatisticItem key={item_0._key} value={item_0.value} shouldAnimate={isIntersecting} headline={getI18nString(item_0.headline) || undefined} description={nullToUndefined(getI18nValue(item_0.bodyCopy))} />;
    $[6] = isIntersecting;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  const t9 = validItems.map(t8);
  let t10;
  if ($[8] !== t9) {
    t10 = <div className={t7}>{t9}</div>;
    $[8] = t9;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  let t11;
  if ($[10] !== t10 || $[11] !== t6) {
    t11 = <div className={t4}><div className={t5}>{t6}{t10}</div></div>;
    $[10] = t10;
    $[11] = t6;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== ref || $[14] !== t11 || $[15] !== t2) {
    t12 = <section ref={ref} className={t2} data-testid={t3}>{t11}</section>;
    $[13] = ref;
    $[14] = t11;
    $[15] = t2;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  return t12;
}
function _temp(item) {
  return Boolean(item.value);
}